/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ItemFromJSON, ItemToJSON, } from './Item.js';
/**
 * Check if a given object implements the ListEducationLevelsResult interface.
 */
export function instanceOfListEducationLevelsResult(value) {
    if (!('educationLevels' in value) || value['educationLevels'] === undefined)
        return false;
    return true;
}
export function ListEducationLevelsResultFromJSON(json) {
    return ListEducationLevelsResultFromJSONTyped(json, false);
}
export function ListEducationLevelsResultFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'educationLevels': (json['educationLevels'].map(ItemFromJSON)),
    };
}
export function ListEducationLevelsResultToJSON(json) {
    return ListEducationLevelsResultToJSONTyped(json, false);
}
export function ListEducationLevelsResultToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'educationLevels': (value['educationLevels'].map(ItemToJSON)),
    };
}
